import React from "react";
import style from "./navbarFilter.module.css";
const NavbarFilter = () => {
  return (
    <div className={`${"nabvar"} ${style.navbar}`}>
      <ul className={style.list}>
        <li>
          {" "}
          <a href="#profil">Profil</a>{" "}
        </li>
        <li>
          {" "}
          <a href="#kegiatan"> Kegiatan</a>
        </li>
        <li>
          <a href="#agenda">Agenda</a>
        </li>
      </ul>
    </div>
  );
};

export default NavbarFilter;
